import { defineMessages } from 'react-intl';

export default defineMessages({
    cancelEditTitle:{
        "id":"useradmin.useractions.Want to Cancel?",
        "defaultMessage":"Want to Cancel?"
    },
    cancelEditMessage:{
        "id":"",
        "defaultMessage":"The information you have entered will not be saved"
    },
    removeUserTitle:{
        "id":"useradmin.useractions.Want to Cancel?",
        "defaultMessage":"Want to Cancel?"
    },
    removeUserMessage:{
        "id":"useradmin.useractions.By clicking OK, you are removing the user's access completely",
        "defaultMessage":"By clicking OK, you are removing the user's access completely"
    },
    BASIC: {
        "id": 'useradmin.view.Basic User',
        "defaultMessage": 'Basic User'
    },
    SAFETYRESOURCES: {
        "id": 'useradmin.view.Safety Resources',
        "defaultMessage": 'Safety Resources'
    },
    POLICY: {
        "id": 'useradmin.view.Policy',
        "defaultMessage": 'Policy'
    },
    BILLING: {
        "id": 'useradmin.view.Billing',
        "defaultMessage": 'Billing'
    },
    PAYROLL: {
        "id": 'useradmin.view.Payroll Reporting',
        "defaultMessage": 'Payroll Reporting'
    },
    CLAIM: {
        "id": 'useradmin.view.Claims',
        "defaultMessage": 'Claims'
    },
    USERADMIN: {
        "id": 'useradmin.view.Account Admin',
        "defaultMessage": 'Account Admin'
    },
    emailUniqueValidation: {
        "id": 'useradmin.view.Email address should be unique',
        "defaultMessage": 'Email address should be unique'
    },
    emailValidation: {
        "id": 'useradmin.view.Please enter a valid email address.',
        "defaultMessage": 'Please enter a valid email address.'
    },
    firstNameValidation: {
        "id": 'useradmin.view.First Name is required.',
        "defaultMessage": 'First Name is required.'
    },
    lastNameValidation: {
        "id": 'useradmin.view.Last Name is required.',
        "defaultMessage": 'Last Name is required.'
    },
    cancelAddTitle: {
        "id": 'useradmin.add.cancel.Want to Cancel?',
        "defaultMessage": 'Want to Cancel?'
    },
    cancelAddMessage: {
        "id": 'useradmin.add.cancel.The information you have entered will not be saved',
        "defaultMessage": 'The information you have entered will not be saved'
    },
    emailAlreadyRegistered: {
        "id": 'useradmin.view.Email address already registered',
        "defaultMessage": 'This email address is already registered with CopperPoint. Please contact customer service if you need further assistance.'
    }
});